import React, { useEffect, useRef, useState } from 'react';
import {
    DataGrid, GridToolbarContainer, gridPageCountSelector,
    gridPageSelector,
    useGridApiContext,
    useGridSelector,
} from '@mui/x-data-grid';

// import { styled } from '@mui/material/styles';
import Pagination from '@mui/material/Pagination';
import Fab from '@mui/material/Fab';
// import Paper from '@mui/material/Paper';
import DownloadingIcon from '@mui/icons-material/Downloading';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import { downloadErrorReport , fileDelete, approveDraft } from "../../API/cjwManageHistoryDownloadApi";
import { downloadDIErrorReport, fileDIDelete, approveDIDraft } from "../../API/cjwReportFileApi";
import { downloadCjwDiApprovedCostFile, downloadCjwDiDraftCostFile } from "../../API/dcCostReportDownloadApi";
import { localDatabaseUrls } from "../../backend/constants";
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Tooltip, TextField, Dialog, DialogActions, Box, DialogTitle, DialogContent, ToggleButton, ToggleButtonGroup, IconButton as MuiIconButton } from "@mui/material";
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { format } from 'date-fns';
import classess from './CJWManageHistory.module.css';
import CJWFilter from './CJWFilters';
// import { useUploadHistory } from '../../templates/CJWManageHistory/CJWManageHistory.hooks';
import IconButton from '@mui/material/IconButton';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import AlertManager from '../../shared/Alert/Alert';
import { useUploadHistoryDelete } from '../../templates/CJWUploadHistory/CJWUploadHistoryDelete.hooks';
import CJWLinkedCostFiles from '../CJWLinkedCostFiles/CJWLinkedCostFiles';
import { isCjwDiDeletableStatus } from '../cjwDiStatus';
import { useCJWDICostFileAvailability } from '../useCJWDICostFileAvailability';
import CJWRecordSummaryCell, { DC_SUMMARY_ITEMS, LC_SUMMARY_ITEMS } from '../CJWUploadHistoryTable/CJWRecordSummaryCell';

// const Item = styled(Paper)(({ theme }) => ({
//     backgroundColor: '#fff',
//     ...theme.typography.body2,
//     padding: theme.spacing(1),
//     textAlign: 'center',
//     color: (theme.vars ?? theme).palette.text.secondary,
//     ...theme.applyStyles('dark', {
//         backgroundColor: '#1A2027',
//     }),
// }));

const CJWManageHistoryTable = ({ uploadHistory, fetchUploadHistory, isPaginationRequired, filterCallBack, loading, isDIMode = false, mode, onModeChange }) => {

    // const { fetchFilterUploads } = useUploadHistory();
    const [gridData, setGridData] = useState(uploadHistory);
    // const [responseData, setResponseData] = useState([]);
    const [approveOpen, setApproveOpen] = useState(false);
    const [selectedFileId, setSelectedFileId] = useState(null);
    // const [isFilter, setIsFilter] = useState(false);
    const [open, setOpen] = useState(false);
    const [expandedFileId, setExpandedFileId] = useState(null);
    const [expandedBatchId, setExpandedBatchId] = useState(null);
    const [isDeleting, setIsDeleting] = useState(false);
    const deleteInProgressRef = useRef(false);
    const costFileAvailability = useCJWDICostFileAvailability(uploadHistory, isDIMode);

    // const [filterModel, setFilterModel] = useState({ items: [] })
    const { fetchUploadHistoryDelete } = useUploadHistoryDelete(isDIMode);
    useEffect(() => {
        if (uploadHistory && uploadHistory.length > 0) {
            uploadHistory.map((item) => {
                item.download = item.status === errorStatus ? 'y' : 'n'
                return item.uploadedDate
            })
            setGridData(uploadHistory);
        }else{
            setGridData([]);
        }
    }, [uploadHistory])

    useEffect(() => {
        setExpandedFileId(null);
        setExpandedBatchId(null);
    }, [isDIMode]);

    const handleDelete = async (fileId) => {
        if (deleteInProgressRef.current) {
            return;
        }

        deleteInProgressRef.current = true;
        setIsDeleting(true);
        try {
            if (isDIMode) {
                await fileDIDelete(fileId, fetchUploadHistoryDelete, setGridData);
            } else {
                await fileDelete(fileId, fetchUploadHistoryDelete, setGridData);
            }
        } catch (error) {
            console.error("Error deleting file:", error);
            AlertManager.error("An unexpected error occurred. Please try again.", { contactSupport: false });
        } finally {
            deleteInProgressRef.current = false;
            setIsDeleting(false);
        }
    };

    const errorStatus = "Processed with errors";
    // const originalStatus = ["Uploaded", "In progress"];


    const handleReset = () => {
        setOpen(false);
        fetchUploadHistory?.();
    }
    const handleFilterOpen = async() => {
        // const x = await fetchFilterUploads();
        // console.log("xxxxxxxxxxxxxxx",x)
        setOpen(true);
    }

    const handleFilterClose = () => setOpen(false);

    const handleApproveOpen = (fileId) => {
        setSelectedFileId(fileId);
        setApproveOpen(true);
    };

    const handleApproveClose = () => {
        setApproveOpen(false);
        setSelectedFileId(null); // Clear the selected ID when closing
    };


    const handleFilterApply = (filterdValues) => {
        try {
            handleFilterClose();
            if (filterdValues) {
                setGridData(filterdValues)
            }

        } catch (error) {
            console.error('Error downloading the file:', error);
        }
    };


    const CustomToolbar = () => {
        return (
            <GridToolbarContainer style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <ToggleButtonGroup
                    value={mode}
                    exclusive
                    onChange={onModeChange}
                    aria-label="CJW mode"
                    sx={{
                        '& .MuiToggleButton-root': {
                            padding: '8px 16px',
                            fontSize: '14px',
                            fontWeight: 600,
                            border: '2px solid #001489',
                            '&.Mui-selected': {
                                backgroundColor: '#001489',
                                color: '#fff',
                                '&:hover': {
                                    backgroundColor: '#001489',
                                }
                            }
                        }
                    }}
                >
                    <ToggleButton value="APG_ASG" aria-label="APG/ASG mode">
                        APG/ASG
                    </ToggleButton>
                    <ToggleButton value="DI" aria-label="DI mode">
                        DI
                    </ToggleButton>
                </ToggleButtonGroup>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button
                        variant="contained"
                        className={classess.filterBtn}
                        onClick={handleFilterOpen}
                    >
                        <FilterAltIcon fontSize="medium" />
                    </Button>
                    <Button
                        variant="contained"
                        className={classess.resetBtn}
                        onClick={handleReset}
                    >
                        Reset
                    </Button>
                </Box>
                <Dialog
                    open={open}
                    onClose={handleFilterClose}
                    maxWidth="lg"
                    PaperProps={{
                        sx: {
                            borderRadius: 2,
                            p: 1,
                            overflow: 'visible'
                        }
                    }}
                    disableEnforceFocus
                >

                    <CJWFilter
                        callBack={(formValues) => handleFilterApply(formValues)}
                        closeCallBack={handleFilterClose}
                        isDIMode={isDIMode} />
                    <DialogActions>
                        <Button onClick={handleFilterClose}>Cancel</Button>
                        {/* <Button onClick={handleFilterApply} variant="contained">Apply</Button> */}
                    </DialogActions>
                </Dialog>
            </GridToolbarContainer>
        )
    }


    const handleApprove = async () => {
        try {
            if (isDIMode) {
                await approveDIDraft(selectedFileId, fetchUploadHistoryDelete, setGridData, handleApproveClose);
            } else {
                await approveDraft(selectedFileId, fetchUploadHistoryDelete, setGridData, handleApproveClose);
            }
        } catch (error) {
            console.error("Error converting draft to approve:", error);
            AlertManager.error("An unexpected error occurred. Please try again.", { contactSupport: false });
        }
    };

    function rowProcess(validRows, totalRows) {
        return totalRows !== null && validRows !== null ? validRows + '/' + totalRows : '0/0';
    }

    function CustomPagination() {
        const apiRef = useGridApiContext();
        const page = useGridSelector(apiRef, gridPageSelector);
        const pageCount = useGridSelector(apiRef, gridPageCountSelector);

        return (
            isPaginationRequired ? <Pagination
                color="primary"
                count={pageCount}
                page={page + 1}
                onChange={(event, value) => apiRef.current.setPage(value - 1)}
            /> : null
        );
    }

    const handleDownload = async (fileId, fileName, downloadFile) => {
        try {
            if (isDIMode) {
                await downloadDIErrorReport(fileId, fileName, downloadFile);
            } else {
                await downloadErrorReport(fileId, fileName, downloadFile);
            }
        } catch (error) {
            console.error('Error downloading the file:', error);
        }
    };

    const handleRowExpand = (fileId, batchId) => {
        const isExpanded = expandedFileId === fileId;
        setExpandedFileId(isExpanded ? null : fileId);
        setExpandedBatchId(isExpanded ? null : batchId);
    };



    // const handleDownload = async (fileId, fileName, downloadFile) => {
    //     console.log("handleDownload called with:", fileId, fileName, downloadFile);
    //     const link = document.createElement('a');
    //     link.href = "/file_example_XLS_10.xls"; 
    //     link.download = `${fileName}`;
    //     link.click(); 
    // }


    const CustomDateFilterInput = (props) => {
        const { item, applyValue } = props;
        const [selectedDate, setSelectedDate] = useState(item.value ? new Date(item.value) : null);

        const handleChange = (newDate) => {
            const formattedDate = newDate ? format(newDate, 'yyyy-MM-dd') : null;
            setSelectedDate(newDate);
            applyValue({ ...item, value: formattedDate });
        };

        return (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                    label="Select Date"
                    value={selectedDate}
                    onChange={(newDate) => handleChange(newDate)}
                    views={['year', 'month', 'day']}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                />
            </LocalizationProvider>
        );
    };

    const CustomDateRangeFilterInput = (props) => {
        const { item, applyValue } = props;
        const [selectedDateRangeFrom, setSelectedDateRangeFrom] = useState(item.value?.from ? new Date(item.value.from) : null);
        const [selectedDateRangeTo, setSelectedDateRangeTo] = useState(item.value?.to ? new Date(item.value.to) : null);

        const handleChange = (newFrom, newTo) => {
            if (newFrom || newTo) {
                applyValue({
                    ...item,
                    value: {
                        from: newFrom ? format(newFrom, 'yyyy-MM-dd') : null,
                        to: newTo ? format(newTo, 'yyyy-MM-dd') : null
                    }
                });
            }
        };

        return (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    <DatePicker
                        label="From Date"
                        value={selectedDateRangeFrom}
                        onChange={(newDate) => {
                            setSelectedDateRangeFrom(newDate);
                            handleChange(newDate, selectedDateRangeTo);
                        }}
                        views={['year', 'month', 'day']}
                        renderInput={(params) => <TextField {...params} fullWidth />}
                    />
                    <DatePicker
                        label="To Date"
                        value={selectedDateRangeTo}
                        onChange={(newDate) => {
                            setSelectedDateRangeTo(newDate);
                            handleChange(selectedDateRangeFrom, newDate);
                        }}
                        views={['year', 'month', 'day']}
                        renderInput={(params) => <TextField {...params} fullWidth />}
                    />
                </div>
            </LocalizationProvider>
        );
    };

    // const handleFilterModelChange = (newFilters) => {
    //     console.log("On server filter change", newFilters);
    //     newFilters = newFilters.items;
    //     setFilterModel(prev => ({
    //         items: [
    //             ...prev.items.filter(
    //                 item => !newFilters.some(f => f.columnField === item.columnField)
    //             ),
    //             ...newFilters
    //         ]
    //     }));
    // }

    // useEffect(() => {
    // console.log("updated filtermodel", filterModel);
    // console.log("full data",gridData);




    // },[filterModel])

    const columns =
        [
            ...(isDIMode ? [{
                field: 'expand',
                headerName: '',
                width: 50,
                sortable: false,
                filterable: false,
                disableColumnMenu: true,
                renderCell: (params) => {
                    const isCjwDiError = params.row.status?.trim().toLowerCase() === 'error';
                    const availability = costFileAvailability[params.row.fileId];
                    const hasApprovedOrDraft = availability?.approvedAvailable === true
                        || availability?.draftAvailable === true
                        || (availability?.approvedAvailable == null && availability?.available === true);
                    const canViewCostFiles = Boolean(params.row.batchId)
                        && !isCjwDiError
                        && hasApprovedOrDraft;
                    return (
                        <Tooltip title={canViewCostFiles
                            ? "View related cost files"
                            : isCjwDiError
                                ? "Cost files are unavailable for a CJW-DI file in Error status"
                                : !params.row.batchId
                                    ? "No linked DC batch is available"
                                    : "No approved or draft cost files are available yet"}>
                            <span>
                                <MuiIconButton
                                    size="small"
                                    onClick={() => handleRowExpand(params.row.fileId, params.row.batchId)}
                                    disabled={!canViewCostFiles}
                                >
                                    {expandedFileId === params.row.fileId ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </MuiIconButton>
                            </span>
                        </Tooltip>
                    );
                }
            }] : []),
            // {
            //     field: 'fileName', flex: 1, headerName: 'File Name-2', sortable: true, filterable: true, width: 200,
            //     renderCell: (params) => {
            //         return (originalStatus.includes(params.row.status) ?
            //             params.row.fileName :
            //             (<Tooltip title={params.row.fileName}>
            //                 <Button style={{ overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: '150px', textOverflow: 'ellipsis', display: 'inline-block' }}
            //                     onClick={() => handleDownload(params.row.id, params.row.fileName, localDatabaseUrls.serviceURL.originalFilePrefix)}>
            //                     {params.row.fileName}
            //                 </Button>
            //             </Tooltip>
            //             )
            //         )

            //     },
            // },
            {
                field: 'fileName',
                headerName: 'File Name',
                flex: 1,
                sortable: true,
                filterable: true,
                width: 140,
                valueGetter: (params) => params.row.fileName, // ensures filtering uses the fileName value
                renderCell: (params) => {
                    return (
                        (
                            <Tooltip title={params.row.fileName}>
                                <Button
                                    style={{
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        maxWidth: '150px',
                                        textOverflow: 'ellipsis',
                                        display: 'inline-block'
                                    }}
                                    onClick={() =>
                                        handleDownload(
                                            params.row.fileId,
                                            params.row.fileName,
                                            localDatabaseUrls.serviceURL.originalFilePrefix
                                        )
                                    }
                                >
                                    {params.row.fileName}
                                </Button>
                            </Tooltip>
                        )
                    );
                }
            },
            {
                field: 'uploadedBy',
                flex: 1,
                headerName: 'Uploaded By',
                sortable: true,
                filterable: true,
                width:150,

            },
            {
                field: 'uploadedDate', flex: 1,
                headerName: 'Uploaded Date',
                sortable: true,
                filterable: true,
                width: 150,
                filterOperators:
                    [
                        {
                            label: 'is',
                            value: 'is',
                            getApplyFilterFn: (filterItem) => {
                                if (!filterItem.columnField || !filterItem.value) {
                                    return null;
                                }
                                const filterDate = new Date(filterItem.value);
                                return ({ value }) => {
                                    const cellDate = new Date(value);
                                    return (cellDate.getFullYear() === filterDate.getFullYear() && cellDate.getMonth() ===
                                        filterDate.getMonth() && cellDate.getDate() === filterDate.getDate())
                                }
                            },
                            InputComponent: CustomDateFilterInput
                        },

                        {
                            label: 'is after',
                            value: 'is after',
                            getApplyFilterFn: (filterItem) => {
                                if (!filterItem.columnField || !filterItem.value) {
                                    return null;
                                }
                                return ({ value }) => new Date(value) > new Date(filterItem.value);
                            },
                            InputComponent: CustomDateFilterInput
                        },
                        {
                            label: 'is before',
                            value: 'is before',
                            getApplyFilterFn: (filterItem) => {
                                if (!filterItem.columnField || !filterItem.value) {
                                    return null;
                                }
                                return ({ value }) => new Date(value) < new Date(filterItem.value);
                            },
                            InputComponent: CustomDateFilterInput
                        }, {
                            label: 'date range',
                            value: 'date range',
                            getApplyFilterFn: (filterItem) => {
                                if (!filterItem.columnField || !filterItem.value) {
                                    return null;
                                }

                                const { from, to } = filterItem.value;
                                const fromDate = from ? new Date(from) : null;
                                const toDate = to ? new Date(to) : null;

                                return ({ value }) => {
                                    const cellDate = new Date(value);
                                    if (fromDate && toDate) {
                                        return cellDate >= fromDate && cellDate <= toDate;
                                    }
                                    if (fromDate) return cellDate >= fromDate;
                                    if (toDate) return cellDate <= toDate;
                                    return true;
                                };
                            },
                            InputComponent: CustomDateRangeFilterInput
                        }
                    ]
            },
            {
                field: 'category',
                flex: 1,
                headerName: 'Category',
                sortable: true,
                filterable: true,
                maxWidth: 90,
                renderCell: (params) => {
                    const isDraftEnabled = isDIMode
                        ? (params.row.status === "Validated" || params.row.status === "Validated with updates")
                        : (params.row.status === "Processed" || params.row.status === "Processed With Updates");

                    if (params.row.category === 'Draft') {
                        return (
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                {params.value}
                                {/* Call the handler with the row ID */}
                                <IconButton
                                    color="error"
                                    size="small"
                                    disabled={!isDraftEnabled}
                                    onClick={() => {
                                        if (isDraftEnabled) { // Only call handleApproveOpen if enabled
                                            handleApproveOpen(params.row.fileId)
                                        }
                                    }} // Pass the ID directly
                                    aria-label="Mark Draft as Ticked"
                                >
                                    <SpellcheckIcon />
                                </IconButton>
                            </Box>
                        );
                    }
                    return params.value;
                },
            },
            ...(!isDIMode ? [{
                field: 'supplierFlag',
                flex: 1,
                headerName: 'APG/ASG',
                sortable: true, filterable: true,
                maxWidth: 90,
            }] : []),
            {
                field: 'status',
                flex: 1,
                headerName: 'Status',
                sortable: true,
                filterable: true,
                maxWidth: 150,
                renderCell: (params) => {
                    if (params.row.obsoleteSku) {
                        return (
                            <Tooltip
                                // title={"Records were removed from this CJW. Download alert report to view details."}
                                title={params.value}
                                arrow
                                slotProps={{
                                    tooltip: {
                                        sx: {
                                            // bgcolor: "transparent",
                                            color: "#fff",
                                            border: "4px solid #fff",
                                            padding: "4px 8px",
                                            borderRadius: "4px",
                                        }
                                    },
                                    arrow: {
                                        sx: {
                                            color: "#726d6dff",
                                        }
                                    }
                                }}
                            >
                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>

                                    {/* <span style={{
                                        width: 8, 
                                        height: 8, 
                                        borderRadius: "50%", 
                                        backgroundColor: "#C82909",
                                        display: "inline-block"
                                    }}></span> */}
                                    <span className={classess.truncateShow}>{params.value}</span>
                                </div>
                            </Tooltip>
                        );
                    }
                }
            },
            ...(isDIMode ? [
                {
                    field: 'lcSummary',
                    headerName: 'LC Summary',
                    width: 120,
                    sortable: false,
                    filterable: false,
                    disableColumnMenu: true,
                    renderCell: (params) => (
                        <CJWRecordSummaryCell
                            title="LC Summary"
                            summary={params.row.lcSummary}
                            items={LC_SUMMARY_ITEMS}
                            available={Boolean(params.row.batchId)}
                        />
                    ),
                },
                {
                    field: 'dcSummary',
                    headerName: 'DC Summary',
                    width: 120,
                    sortable: false,
                    filterable: false,
                    disableColumnMenu: true,
                    renderCell: (params) => (
                        <CJWRecordSummaryCell
                            title="DC Summary"
                            summary={params.row.dcSummary}
                            items={DC_SUMMARY_ITEMS}
                            available={Boolean(params.row.batchId)}
                        />
                    ),
                },
            ] : []),
            {
                field: 'supplierName',
                flex: 1,
                headerName: 'Supplier',
                sortable: true,
                filterable: true,
                maxWidth: 150,
            },
            {
                field: 'isTariff',
                flex: 1,
                headerName: 'Tariff Status',
                sortable: true,
                filterable: true,
                maxWidth: 90,
            },
            {
                field: 'rows',
                flex: 1,
                headerName: 'Rows (Valid/Total)',
                sortable: true, filterable: true, width: 200,
                valueGetter: (params) => rowProcess(params.row.validRows, params.row.totalRows),
            },
            {
                field: 'download',
                flex: 1,
                headerName: 'Download report',
                sortable: true,
                disableColumnMenu: true, width: isDIMode ? 300 : 250,
                minWidth: isDIMode ? 280 : 200,
                renderCell: (params) => {
                    const isFileDownloadDisabled = params.row.status === "Uploaded" || params.row.status === "In progress";
                    const availability = costFileAvailability[params.row.fileId];
                    const isCostFileEnabled = isDIMode
                        ? !isFileDownloadDisabled
                        : params.row.status === "Processed" || params.row.status === "Processed With Updates" || params.row.status === "Processed with errors";
                    const isErrorStatus = isDIMode
                        ? isCjwDiDeletableStatus(params.row.status)
                        : params.row.status === "Error" || params.row.status === "Processed with errors" || params.row.status === "Validation failed";
                    const isUpdateFileEnabled = isDIMode
                        ? !isFileDownloadDisabled
                        : params.row.status === "Processed With Updates" || params.row.status === "Processed" || params.row.status === "Processed with errors" || params.row.status === "Error" || params.row.status === "Cost file processing error";
                    // const enableAlert = params
                      return (
                        <Box display="flex" gap={1}>
                            <Tooltip title="Download transformed CJW file containing updates, error and cost threshold alert">
                                <Fab size="small"
                                    sx={{
                                        backgroundColor: 'transparent',
                                        boxShadow: 'none',
                                        cursor: isUpdateFileEnabled ? 'pointer' : 'default',
                                        '&:hover': {
                                            backgroundColor: 'transparent' // keep Fab itself transparent
                                        }
                                    }}
                                    disabled={!isUpdateFileEnabled} // Set disabled prop based on the condition
                                    onClick={() => {
                                        if (isUpdateFileEnabled) {
                                            handleDownload(params.row.fileId, params.row.fileName, isDIMode ? 'validated' : localDatabaseUrls.serviceURL.processString)
                                        }
                                    }}
                                >

                                    <DownloadingIcon
                                        sx={{
                                            color: !isUpdateFileEnabled ? 'grey' : 'black',
                                            transition: 'color 0.1s ease-in-out',
                                            '&:hover': !isUpdateFileEnabled
                                                ? {} // no hover effect if disabled
                                                : { color: '#02347ed0' } // dark green when enabled + hover
                                        }}
                                    />

                                </Fab>
                            </Tooltip>
                            <Tooltip title="Download excluded records because of Obsolete and zero current cost conditions">
                                <Fab
                                    size="small"
                                    disabled={!params.row.obsoleteSku}
                                    sx={{
                                        backgroundColor: 'transparent',
                                        boxShadow: 'none',
                                        cursor: params.row.obsoleteSku ? 'pointer' : 'default',
                                        '&:hover': {
                                            backgroundColor: 'transparent' // keep Fab itself transparent
                                        }
                                    }}
                                >
                                    <DownloadForOfflineIcon
                                        onClick={() =>
                                            params.row.obsoleteSku &&
                                            handleDownload(
                                                params.row.fileId,
                                                params.row.fileName,
                                                isDIMode ? 'obsolete' : localDatabaseUrls.serviceURL.obsoleteString
                                            )
                                        }
                                        sx={{
                                            color: !params.row.obsoleteSku ? 'grey' : 'black',
                                            transition: 'color 0.1s ease-in-out',
                                            '&:hover': !params.row.obsoleteSku
                                                ? {} // no hover effect if disabled
                                                : { color: '#02347ed0' } // dark green when enabled + hover
                                        }}
                                    />
                                </Fab>
                            </Tooltip>

                            {(() => {
                                // In DI mode the cost file is downloaded from the DC-cost batch.
                                const isDiCostFile = isDIMode;
                                const diHasBatch = isDiCostFile && Boolean(params.row.batchId);
                                const isCjwDiError = isDiCostFile
                                    && params.row.status?.trim().toLowerCase() === 'error';
                                const approvedAvailable = availability?.approvedAvailable === true
                                    || (availability?.approvedAvailable == null && availability?.available === true);
                                const costEnabled = isDiCostFile
                                    ? (diHasBatch && !isCjwDiError && approvedAvailable)
                                    : isCostFileEnabled;
                                const costTooltip = isDiCostFile
                                    ? (isCjwDiError
                                        ? "Cost files are unavailable for a CJW-DI file in Error status"
                                        : approvedAvailable
                                            ? "Download approved consolidated cost file"
                                            : "Approved cost file is not available")
                                    : "Download generated cost file";
                                const onCostClick = async () => {
                                    if (!costEnabled) return;
                                    if (isDiCostFile) {
                                        await downloadCjwDiApprovedCostFile(params.row.fileId);
                                    } else {
                                        handleDownload(params.row.fileId, params.row.fileName, localDatabaseUrls.serviceURL.costFilePrefix);
                                    }
                                };
                                return (
                                    <Tooltip title={costTooltip}>
                                        <span>
                                            <Fab
                                                size="small"
                                                sx={{
                                                    backgroundColor: 'transparent',
                                                    boxShadow: 'none',
                                                    cursor: costEnabled ? 'pointer' : 'default',
                                                    '&:hover': {
                                                        backgroundColor: 'transparent'
                                                    }
                                                }}
                                                disabled={!costEnabled}
                                                onClick={onCostClick}
                                            >
                                                <DownloadingIcon
                                                    sx={{
                                                        color: !costEnabled ? 'grey' : 'black',
                                                        transition: 'color 0.1s ease-in-out',
                                                        '&:hover': !costEnabled
                                                            ? {}
                                                            : { color: '#02347ed0' }
                                                    }} />
                                            </Fab>
                                        </span>
                                    </Tooltip>
                                );
                            })()}

                            {isDIMode && (() => {
                                const isCjwDiError = params.row.status?.trim().toLowerCase() === 'error';
                                const draftCostEnabled = Boolean(params.row.batchId)
                                    && !isCjwDiError
                                    && availability?.draftAvailable === true;
                                const draftTooltip = isCjwDiError
                                    ? "Cost files are unavailable for a CJW-DI file in Error status"
                                    : draftCostEnabled
                                        ? "Download draft consolidated cost file"
                                        : "Draft cost file is not available";

                                return (
                                    <Tooltip title={draftTooltip}>
                                        <span>
                                            <Fab
                                                size="small"
                                                sx={{
                                                    backgroundColor: 'transparent',
                                                    boxShadow: 'none',
                                                    cursor: draftCostEnabled ? 'pointer' : 'default',
                                                    '&:hover': {
                                                        backgroundColor: 'transparent'
                                                    }
                                                }}
                                                disabled={!draftCostEnabled}
                                                aria-label={'Download draft consolidated cost file'}
                                                onClick={() => {
                                                    if (draftCostEnabled) {
                                                        downloadCjwDiDraftCostFile(params.row.fileId);
                                                    }
                                                }}
                                            >
                                                <DownloadingIcon
                                                    sx={{
                                                        color: !draftCostEnabled ? 'grey' : 'black',
                                                        transition: 'color 0.1s ease-in-out',
                                                        '&:hover': !draftCostEnabled
                                                            ? {}
                                                            : { color: '#02347ed0' }
                                                    }} />
                                            </Fab>
                                        </span>
                                    </Tooltip>
                                );
                            })()}

                            {isDIMode && (
                                <Tooltip title="Download Purchase Cost File">
                                    <Fab
                                        size="small"
                                        sx={{
                                            backgroundColor: 'transparent',
                                            boxShadow: 'none',
                                            cursor: isCostFileEnabled ? 'pointer' : 'default',
                                            '&:hover': {
                                                backgroundColor: 'transparent'
                                            }
                                        }}
                                        disabled={!isCostFileEnabled}
                                        onClick={() => {
                                            if (isCostFileEnabled) {
                                                handleDownload(params.row.fileId, params.row.fileName, localDatabaseUrls.serviceURL.purchaseCostFilePrefix);
                                            }
                                        }}
                                    >
                                        <DownloadingIcon
                                            sx={{
                                                color: !isCostFileEnabled ? 'grey' : 'black',
                                                transition: 'color 0.1s ease-in-out',
                                                '&:hover': !isCostFileEnabled
                                                    ? {}
                                                    : { color: '#02347ed0' }
                                            }}
                                        />
                                    </Fab>
                                </Tooltip>
                            )}

                            <Tooltip title="Delete errored CJW">
                                <Fab
                                    size="small"
                                    sx={{ backgroundColor: 'transparent', boxShadow: 'none', '&:hover': { backgroundColor: 'transparent' } }}
                                    disabled={!isErrorStatus || isDeleting}
                                    aria-label="Delete errored CJW"
                                    onClick={() => {
                                        if (isErrorStatus && !isDeleting) {
                                            handleDelete(params.row.fileId);
                                        }
                                    }}
                                >
                                    <DeleteIcon />
                                </Fab>
                            </Tooltip>

                            {/* <Tooltip title="Delete">
                                <Fab size="small" sx={{ backgroundColor: 'transparent', boxShadow: 'none', '&:hover': { backgroundColor: 'transparent' } }} disabled={!isErrorStatus} >
                                    <DeleteIcon
                                        onClick={() => {
                                            if (isErrorStatus) { // Only call handleDownload if enabled
                                                handleDownload(params.row.id, params.row.fileName);
                                            }
                                        }} />
                                </Fab>
                            </Tooltip> */}

                        </Box>
                    );
                }

            }
        ]
    return (


        <div
            style={{
                minWidth: 0,
                maxWidth: '100vw',
                margin: '0 auto',
                display: 'flex',
                flexDirection: 'column',
                background: '#fff',
                paddingRight: '80px'
            }}
        >
            <div style={{ flex: 1, overflow: 'visible', width: '105%' }}> {/* Consider removing or adjusting 'flex: 1' if it causes issues */}
                <DataGrid
                    components={{
                        Toolbar: CustomToolbar,
                        Pagination: CustomPagination, // You might remove this if pagination is completely disabled
                    }}
                    rows={loading ? [] : gridData}
                    columns={columns} // Ensure your column definitions use 'flex' for responsive sizing
                    disableRowSelectionOnClick
                    pagination // Disable pagination to show all rows
                    pageSize={10} // Remove pageSize as pagination is disabled
                    autoHeight={true} // Enable autoHeight to fit all rows
                    loading={loading}
                    sortingMode="client"
                    getRowId={(row) => row.fileId}
                    filterMode="client"
                    rowThreshold={0}
                    sx={{
                        width: '100%',
                        minWidth: 0,
                        maxWidth: '100vw',
                        '& .MuiDataGrid-columnHeaderTitle': {
                            fontWeight: 'bold',
                        },
                        '& .MuiDataGrid-toolbarcontainer': {
                            display: 'flex',
                            justifyContent: 'space-between',
                        },
                        '& .MuiDataGrid-cellContent': {
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        },
                        // If scrollbars persist, add this to hide them
                        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
                            display: 'none',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            width: '100%',
                            minWidth: 0,
                            maxWidth: '100vw',
                        }
                    }}
                />
                {isDIMode && expandedFileId !== null ? (
                    <Box sx={{ mt: 2, width: '100%' }}>
                        <CJWLinkedCostFiles
                            batchId={expandedBatchId}
                        />
                    </Box>
                ) : null}
                <Dialog
                    open={approveOpen}
                    onClose={handleApproveClose}
                    aria-labelledby="alert-dialog-title"
                >
                    <DialogTitle id="alert-dialog-title">Confirm Approval</DialogTitle>
                    <DialogContent>
                        Are you sure you want to approve?
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleApproveClose}>Cancel</Button>
                        <Button onClick={handleApprove} autoFocus>
                            Apply
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>

    );
}

export default CJWManageHistoryTable;
